import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './styles';
import { UpcomingRounds } from '../UpcomingRounds';
import Terms from '../Terms';
import { CountdownTimer } from '../CountdownTimer';
import { EnterPrompt } from '../EnterPrompt';
import LoginPrompt from '../LoginPrompt';
import PreEventInfo from '../PreEventInfo';
import PrizeAsset from '../PrizeAsset/component';
import { useSportConfig } from '../../hooks/useSportConfig';

const OpenState = ({
    eventName,
    prize,
    prizeImageUrl,
    TermsLink,
    loggedIn,
    sweepId,
    openLogin,
    startDate,
    canEnterSweepstake,
    displayCountdownTimer
}) => {
    const { config } = useSportConfig();
    return (
        <>
            {displayCountdownTimer && (
                <Styled.CountDownTimerWrapper>
                    {startDate && (
                        <CountdownTimer
                            name={eventName}
                            date={new Date(startDate).getTime()}
                        />
                    )}
                </Styled.CountDownTimerWrapper>
            )}
            <Styled.ContentWrapper>
                {prizeImageUrl && (
                    <PrizeAsset prize={prize} prizeImageUrl={prizeImageUrl} />
                )}
                <PreEventInfo>
                    {canEnterSweepstake && (
                        <>
                            <Styled.ButtonWrapper>
                                {loggedIn ? (
                                    <EnterPrompt sweepId={sweepId} />
                                ) : (
                                    <LoginPrompt
                                        openLogin={openLogin}
                                        hasEventStarted={false}
                                    />
                                )}
                            </Styled.ButtonWrapper>
                            <Terms
                                startDate={startDate}
                                TermsLink={TermsLink}
                            />
                        </>
                    )}
                </PreEventInfo>
                {config.features.hasUpcomingRounds && (
                    <Styled.UpComingRoundsWrapper>
                        <UpcomingRounds />
                    </Styled.UpComingRoundsWrapper>
                )}
            </Styled.ContentWrapper>
        </>
    );
};

OpenState.propTypes = {
    eventName: PropTypes.string.isRequired,
    prize: PropTypes.string.isRequired,
    prizeImageUrl: PropTypes.string,
    TermsLink: PropTypes.func.isRequired,
    loggedIn: PropTypes.bool.isRequired,
    sweepId: PropTypes.string.isRequired,
    openLogin: PropTypes.func.isRequired,
    startDate: PropTypes.string.isRequired,
    canEnterSweepstake: PropTypes.bool.isRequired,
    displayCountdownTimer: PropTypes.bool.isRequired
};

OpenState.defaultProps = {
    prizeImageUrl: null
};

export default OpenState;
